import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { REDUCER, ACTION } from "../constants/redux";

const initialState = { filter: null };

const persistConfig = {
  key: REDUCER.SONG,
  storage: storage,
};

const songReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case ACTION.SET_SONG_FILTER:
    return {
      ...state,
      filter: payload,
    };
  default:
    return state;
  }
};

export default persistReducer(persistConfig, songReducer);
